module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--medium@2x-4fbc9a87842609d12525fe4fe664339a.jpg";